module.exports = __webpack_public_path__ + "static/media/sector4.b25e9375.svg";